import { configureStore } from '@reduxjs/toolkit';

import { categoriesSlice } from '@/store/modules/categories';
import { pictogramsSlice } from '@/store/modules/pictograms';
import { reviewsSlice } from '@/store/modules/reviews';
import { tagsSlice } from '@/store/modules/tags';
import { howToReviewsSlice } from './modules/howToReviews';

export const store = configureStore({
  devTools: false,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
  reducer: {
    categories: categoriesSlice.reducer,
    pictograms: pictogramsSlice.reducer,
    reviews: reviewsSlice.reducer,
    howToReviews: howToReviewsSlice.reducer,
    tags: tagsSlice.reducer
  }
});
